import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { ShadowContainer, makeStyles, RaiseColors, Typography, Icon, IconConstants } from "componentLibrary";
import TextLink from "componentLibrary/TextLink/TextLink";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var useWorkplaceOSLoginStyles = makeStyles(function (theme) {
  return {
    container: {
      borderRadius: "24px"
    },
    shadowContainer: {
      borderRadius: "24px !important",
      boxShadow: "0px 4px 32px 0px rgba(141,139,153,0.2) !important"
    },
    containerDiv: _defineProperty({
      display: "flex",
      flexDirection: "column",
      padding: 32,
      width: 495
    }, theme.breakpoints.down("smMd"), {
      width: "calc(360px - 32px)",
      padding: "24px 16px"
    }),
    errorDiv: {
      backgroundColor: RaiseColors.destructive100,
      padding: "12px 24px",
      border: "1px solid ".concat(RaiseColors.destructive500),
      borderRadius: "8px",
      marginBottom: "24px",
      display: "flex",
      gap: "10px",
      alignItems: "flex-start"
    },
    containerIcon: {
      display: "flex",
      width: "40px",
      height: "40px",
      padding: "8px 12px",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      borderRadius: "200px",
      border: "1px solid var(--neutral-neutral-300, #E8E7EB)",
      background: "var(--neutral-neutral-100, #FFF)",
      boxShadow: " 0px 0px 8px 0px rgba(73, 0, 227, 0.08)",
      cursor: "pointer",
      marginRight: 12
    },
    termsDiv: _defineProperty({
      display: "flex",
      alignItems: "center",
      gap: 24,
      marginTop: 32
    }, theme.breakpoints.down("smMd"), {
      marginTop: 16
    }),
    linkText: {
      textDecoration: "none"
    },
    containerItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 24
    },
    containerHeader: {
      display: "flex",
      flexDirection: "column",
      flex: 1
    },
    headerTitle: _defineProperty({}, theme.breakpoints.down("smMd"), {
      fontSize: "18px",
      lineHeight: "24px",
      letterSpacing: "-0.36px"
    }),
    formikLabel: {
      marginBottom: 8
    },
    textField: {
      backgroundColor: RaiseColors.neutral100,
      color: RaiseColors.gray100
    },
    textFieldInputRoot: {
      height: "48px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid ".concat(RaiseColors.grayscale200)
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "1px solid ".concat(RaiseColors.grayscale900)
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid ".concat(RaiseColors.bahama1200)
      },
      "&.Mui-focused:hover .MuiOutlinedInput-notchedOutline": {
        border: "1px solid ".concat(RaiseColors.bahama1200)
      },
      "& input:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset"),
        WebkitTextFillColor: RaiseColors.midnight,
        transition: "background-color 5000s ease-in-out 0s"
      },
      "& input:-webkit-autofill:hover": {
        WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset")
      },
      "& input:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset")
      }
    },
    errorIconContainer: {
      width: "20px",
      height: "20px",
      flexShrink: 0
    },
    errorMessageContainer: {
      flex: 1
    },
    errorMessageText: {
      whiteSpace: "normal"
    }
  };
});
export var WorkplaceOSLoginContainer = function WorkplaceOSLoginContainer(_ref) {
  var _context;
  var children = _ref.children,
    className = _ref.className;
  var classes = useWorkplaceOSLoginStyles();
  return /*#__PURE__*/_jsx(ShadowContainer, {
    className: classes.shadowContainer,
    children: /*#__PURE__*/_jsx("div", {
      className: classes.container,
      children: /*#__PURE__*/_jsx("div", {
        className: className ? _concatInstanceProperty(_context = "".concat(classes.containerDiv, " ")).call(_context, className) : classes.containerDiv,
        children: children
      })
    })
  });
};
export var WorkplaceOSLoginHeader = function WorkplaceOSLoginHeader(_ref2) {
  var title = _ref2.title,
    subHeader = _ref2.subHeader,
    onBack = _ref2.onBack;
  var classes = useWorkplaceOSLoginStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.containerItem,
    children: [onBack && /*#__PURE__*/_jsx("div", {
      className: classes.containerIcon,
      onClick: onBack,
      children: /*#__PURE__*/_jsx(Icon, {
        className: IconConstants.ARROW_LEFT,
        color: RaiseColors.midnight,
        fontSize: "18px"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.containerHeader,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h4",
        weight: "semibold",
        className: classes.headerTitle,
        children: title
      }), subHeader && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_medium",
        children: subHeader
      })]
    })]
  });
};
export var WorkplaceOSLoginLabel = function WorkplaceOSLoginLabel(_ref3) {
  var children = _ref3.children;
  var classes = useWorkplaceOSLoginStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classes.formikLabel,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      color: RaiseColors.midnight,
      children: children
    })
  });
};
export var WorkplaceOSLoginError = function WorkplaceOSLoginError(_ref4) {
  var message = _ref4.message;
  var classes = useWorkplaceOSLoginStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.errorDiv,
    children: [/*#__PURE__*/_jsx("div", {
      className: classes.errorIconContainer,
      children: /*#__PURE__*/_jsx(Icon, {
        className: IconConstants.EXCLAMATION_TRIANGLE,
        color: RaiseColors.destructive500,
        fontSize: "20px"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classes.errorMessageContainer,
      children: /*#__PURE__*/_jsx(Typography, {
        color: RaiseColors.destructive500,
        weight: "semibold",
        variant: "paragraph_medium",
        className: classes.errorMessageText,
        children: message
      })
    })]
  });
};
export var WorkplaceOSLoginTerms = function WorkplaceOSLoginTerms() {
  var classes = useWorkplaceOSLoginStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.termsDiv,
    children: [/*#__PURE__*/_jsx("a", {
      href: "https://www.jllt.com/legal-agreements/jllt/terms-of-service/",
      target: "_blank",
      rel: "noopener noreferrer",
      className: classes.linkText,
      children: /*#__PURE__*/_jsx(TextLink, {
        children: "Terms of Service"
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "https://www.us.jll.com/en/privacy-statement",
      target: "_blank",
      rel: "noopener noreferrer",
      className: classes.linkText,
      children: /*#__PURE__*/_jsx(TextLink, {
        children: "Privacy Policy"
      })
    })]
  });
};